<script>
  import Index from "./_index.svelte";
  import { crossfade, scale } from "svelte/transition";
  import { Subscriber, collections } from "@/meteor.js";

  export let route, routes, url;
  const [send, receive] = crossfade({ duration: 500, fallback: scale });

  $: userId = route.params.userId;
  const {users} = collections;
  $: user = $users[userId];

  
  const userSubscription = Subscriber('users')
  $userSubscription
</script>

<div>
  <Index {send} {receive} {userId} {users} />
  <slot scoped={{ send, receive, user, userId }} />
</div>
